<template lang="pug">
  input.form-control(
    type="password"
    v-model="currentValue"
    :id="'form-'+name"
    :disabled="disabled"
    :placeholder="placeholder"
    @keyup="changeValue")
</template>

<script>
import { encrypt } from '@/utils/common'
export default {
  props: {
    name: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  methods: {
    changeValue (event) {
      this.$emit('input', encrypt(event.target.value))
    }
  }
}
</script>




// WEBPACK FOOTER //
// SmartPassword.vue?ebb4b4c0